module.exports = __webpack_public_path__ + "img/Logo.7a915cb8.png";